<template>
  <div ref="mapContainer" class="w-full h-96 sm:h-20vw  map-container"></div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import mapboxgl from 'mapbox-gl'

mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_API_KEY;

const mapContainer = ref(null)
const map = ref(null)

// Receive stops as prop
const props = defineProps({
  stops: { type: Array, required: true }, 
  highlightIndex: { type: Number, default: 0 } // the stop to highlight
})

onMounted(() => {
  if (!props.stops.length) return

  map.value = new mapboxgl.Map({
    container: mapContainer.value,
    style: 'mapbox://styles/mapbox/streets-v11',
    center: [props.stops[0].longitude, props.stops[0].latitude],
    zoom: 9
  })

  // Wait for map to finish loading style
  map.value.on('load', () => {
    renderStops()
  })
})

watch(
    () => props.stops,
    () => {
      if (map.value && map.value.isStyleLoaded()) {
        renderStops()
      } else if (map.value) {
        map.value.on('load', () => renderStops())
      }
    }
)


watch(() => props.stops, () => {
  renderStops()
})

watch(
    () => props.highlightIndex,
    () => {
      renderStops() // remove old markers and redraw all
    }
)

function renderStops() {
  if (!map.value) return

  // Clear previous markers & layers
  if (map.value.getLayer('route-line')) map.value.removeLayer('route-line')
  if (map.value.getSource('route')) map.value.removeSource('route')

  // Add markers
  props.stops.forEach((stop, index) => {
    const isHighlighted = stop.name === props.stops[props.highlightIndex]?.name

    const marker = new mapboxgl.Marker({
      color: isHighlighted ? "#ef4444" : "#1b84ff"
    })
        .setLngLat([stop.longitude, stop.latitude])
        .setPopup(new mapboxgl.Popup().setText(stop.name))
        .addTo(map.value)
  })


  // Draw route
  map.value.addSource('route', {
    type: 'geojson',
    data: {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: props.stops.map(s => [s.longitude, s.latitude])
      }
    }
  })

  map.value.addLayer({
    id: 'route-line',
    type: 'line',
    source: 'route',
    layout: { 'line-join': 'round', 'line-cap': 'round' },
    paint: { 'line-color': '#FFFFF0', 'line-width': 4, 'line-dasharray': [2, 2] }
  })
}
</script>

<style>
.w-full.h-96 {
  width: 100%;
  height: 400px;
}

.map-container {
  border: 4px black;
}
</style>
